import script from "./AlertsBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertsBox.vue?vue&type=script&setup=true&lang=js"

import "./AlertsBox.vue?vue&type=style&index=0&id=47ab86de&lang=css"

const __exports__ = script;

export default __exports__